module.exports = __webpack_public_path__ + "static/media/defaultFileIcon.ae36ab99.svg";